<div [style.--company-color]="companyColor()">
  <section>
    <app-contract-view [contract]="contract()" [schedules]="schedules()"></app-contract-view>
  </section>
  <mat-divider></mat-divider>
  <section>
    <app-employee-view [contact]="contact()"></app-employee-view>
  </section>
  <mat-divider></mat-divider>
  <section>
    <app-schedules-view
      [contract]="contract()"
      [schedules]="schedules()"
      [previous]="previousSchedules()"
    ></app-schedules-view>
  </section>
  <mat-divider></mat-divider>
  <section>
    <app-assignment-view
      [assignment]="assignment()"
      [previous]="previousAssignment()"
    ></app-assignment-view>
  </section>
  <mat-divider></mat-divider>
  <section>
    <app-documents-view
      [documents]="documents()"
      (selected)="openDocument.emit($event)"
    ></app-documents-view>
  </section>
</div>
